import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, Instagram } from "lucide-react";
import AnimatedBackground from "@/components/AnimatedBackground";
import Logo from "@/components/Logo";
import { WindowsDownload } from "@/components/WindowsDownload";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const nav = useNavigate();

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (!res.ok) {
            toast.error(res.error);
            return;
        }
        toast.success("Hoş geldiniz");
        nav("/dashboard");
    }

    return (
        <div className="dk-landing min-h-screen flex items-center justify-center px-4">
            <AnimatedBackground />
            <Card className="relative z-10 w-full max-w-md dk-glass border-white/60 shadow-2xl">
                <CardContent className="p-8">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 mb-6"
                    >
                        <Logo size={36} />
                        <span className="font-bold text-lg text-slate-900">
                            DentDefter
                        </span>
                    </Link>
                    <h1 className="text-2xl font-bold text-slate-900">
                        Panele Giriş
                    </h1>
                    <p className="text-sm text-slate-600 mt-1">
                        Süper admin, patron veya personel hesabınızla giriş
                        yapın
                    </p>
                    <form onSubmit={onSubmit} className="mt-6 space-y-4">
                        <div>
                            <Label htmlFor="email">Kullanıcı Adı</Label>
                            <Input
                                id="email"
                                type="text"
                                autoComplete="username"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="kullanici_adi"
                                data-testid="login-email-input"
                                className="mt-1.5 bg-white"
                            />
                        </div>
                        <div>
                            <Label htmlFor="password">Şifre</Label>
                            <Input
                                id="password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="login-password-input"
                                className="mt-1.5 bg-white"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={loading}
                            className="dk-btn-primary w-full h-11 rounded-lg"
                            data-testid="login-submit-btn"
                        >
                            {loading ? (
                                <Loader2 className="w-4 h-4 animate-spin" />
                            ) : (
                                "Giriş Yap"
                            )}
                        </Button>
                    </form>
                    <div className="mt-6 pt-5 border-t border-slate-200/70 text-center">
                        <p className="text-xs text-slate-500 leading-relaxed mb-3">
                            Yeni bir klinik olarak katılmak ve patron üyeliği
                            almak için:
                        </p>
                        <a
                            href="https://www.instagram.com/luxbeamyazilim"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="patron-signup-instagram-link"
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045] text-white text-sm font-semibold shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all"
                        >
                            <Instagram className="w-4 h-4" />
                            @luxbeamyazilim
                        </a>
                        <p className="text-[11px] text-slate-400 mt-2">
                            Patron hesabı talebi için Instagram üzerinden
                            iletişime geçin
                        </p>
                    </div>
                    <WindowsDownload />
                </CardContent>
            </Card>
        </div>
    );
}
